import { Link, useLocation } from 'react-router-dom';
import { useI18n } from '../lib/i18n.js';
import { Mono } from '../components/ui.js';

/**
 * A real not-found screen.
 *
 * Silently redirecting an unknown URL to the dashboard leaves a clerk who
 * mistyped, or followed a stale bookmark, with no idea what happened.
 */
export function NotFoundPage() {
  const { t } = useI18n();
  const location = useLocation();

  return (
    <div className="mx-auto max-w-md px-4 py-20 text-center">
      <p className="text-[2.5rem] font-semibold leading-none text-navy-700 tabular">404</p>
      <h1 className="mt-3 text-lg font-semibold">{t('notFound.title')}</h1>
      <p className="mt-2 text-ink-500">{t('notFound.hint')}</p>

      <Mono className="mt-3 block break-all text-ink-400">{location.pathname}</Mono>

      <div className="mt-6 flex justify-center gap-2">
        <Link to="/" className="btn-primary">
          {t('nav.dashboard')}
        </Link>
        <Link to="/search" className="btn-secondary">
          {t('nav.search')}
        </Link>
      </div>
    </div>
  );
}
